import React, { useEffect } from 'react'
import NotificationManagementColumnModel from './notification-management-column-model'
import CommonTablePage, { CommonTablePagePropsInterface } from '../../../components/common/common-table/common-table-page'
import { urlKey, urlType } from '../../../services/api/api-urls'
import { toLocalDate } from '../../../services/lib/utils/helpers'
import { useDocumentTitle } from '../../../services/title/useDocumentTitle'
import { getUserId } from '../../../services/lib/utils/auth.utils'

const NotificationManagementPage = () => {
  // useEffect(() => {
  //   document.title = "Notification Management";
  //   },[]);
    useDocumentTitle();
  const commonTablePageProps: CommonTablePagePropsInterface = {
    urlInfoKey: urlKey.Notification,
    title: 'Notification Management',
    column: NotificationManagementColumnModel(),
    mappingUpdateData: (dataDetail: any, type: any) => {
      console.log('mappingUpdateData input:', dataDetail)
      dataDetail.createrId = dataDetail.employeeId
      if (type === urlType.Create) {
        const currentUserId = getUserId()
        dataDetail.createrId = currentUserId
        dataDetail.createdAt = (new Date()).toISOString()
      } else {
        dataDetail.createrId = dataDetail.employeeId
      }
        // Convert isActive1 string to boolean
      dataDetail.isActive = dataDetail.isActive1 == 1 || dataDetail.isActive1 === "1";
      if (dataDetail.startDate1 !== toLocalDate(dataDetail.startDate)) {
        dataDetail.startDate = dataDetail.startDate1
      }
      if (dataDetail.endDate1 !== toLocalDate(dataDetail.endDate)) {
        dataDetail.endDate = dataDetail.endDate1
      }
      dataDetail.roleId = 1 // Set roleId to 1 (Admin)

      // Ensure employeeIds is included (empty array for all, specific IDs otherwise)
      // If employeeIds is undefined/null/empty, default to [] (all employees)
      if (dataDetail.employeeIds === undefined || dataDetail.employeeIds === null) {
        dataDetail.employeeIds = []
      }
      // Ensure it's always an array
      if (!Array.isArray(dataDetail.employeeIds)) {
        dataDetail.employeeIds = []
      }

      console.log('mappingUpdateData output employeeIds:', dataDetail.employeeIds)
      return dataDetail
    },
    mappingRenderData: (data: any) => data.map((row: any) => {
      console.log('mappingRenderData row:', row)
      // Extract employeeIds from employeeNotifications if it exists
      let employeeIds = row.employeeIds || []
      if (row.employeeNotifications && Array.isArray(row.employeeNotifications)) {
        employeeIds = row.employeeNotifications.map((en: any) => en.employeeId)
      }
      console.log('mappingRenderData employeeIds:', employeeIds)
      return {
        ...row,
        employeeId: row.createrId,
        employee: row.creater,
        employeeIds: employeeIds, // Use employeeNotifications data if available
        startDate1: toLocalDate(row.startDate),
        endDate1: toLocalDate(row.endDate),
        isActive1: row.isActive ? 1 : 0
      }
    })
  }

  return (
    <div>
      <CommonTablePage {...commonTablePageProps} />
    </div>
  )
}

export default NotificationManagementPage

